/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ConfigurationForAwsConsolidatedChargesReport extends models.ConfigurationForFinOpsConsolidatedReport {
    constructor() {
        super();
        this.setDiscriminator("ConfigurationForAwsConsolidatedChargesReport");
    }

    getFixupPrototypeFunction() { return ConfigurationForAwsConsolidatedChargesReport.fixupPrototype; }

    static newInstance(model: Partial<ConfigurationForAwsConsolidatedChargesReport>): ConfigurationForAwsConsolidatedChargesReport {
        let obj = Object.assign(new ConfigurationForAwsConsolidatedChargesReport(), model);
        ConfigurationForAwsConsolidatedChargesReport.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ConfigurationForAwsConsolidatedChargesReport>): ConfigurationForAwsConsolidatedChargesReport {
        if (!model) return null;
        return ConfigurationForAwsConsolidatedChargesReport.newInstance(<ConfigurationForAwsConsolidatedChargesReport> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ConfigurationForAwsConsolidatedChargesReport) {
        if (!obj) return;

        models.ConfigurationForAwsConsolidatedChargesReport.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ConfigurationForAwsConsolidatedChargesReport): boolean {
        if (models.ConfigurationForFinOpsConsolidatedReport.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ConfigurationForAwsConsolidatedChargesReport.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
